import * as React from 'react'
import * as i18next from 'i18next'
import { Widget, mk_widget } from 'widgets-for-react'

export const loader: Widget<never> = mk_widget({
  run: (o) => <Loader />
})

export const loaderStyleguide = () => (
  <div className="loader">
    <div className="loader__inner">
      <span className="sr-text">{i18next.t('Common:ContentIsLoading')}</span>
      <img src="/frontend/images/loader.gif" alt="" />
    </div>
  </div>
)

class Loader extends React.Component<{}, {}> {
  render() {
    return (
      <div className="main">
      <div className="loader">
        <div className="loader__inner"></div>
      </div>
    </div>
    )
  }
}
